import { Box, Grid2 } from "@mui/material"
import { Link } from "react-router-dom"
import usecases from "../../../providers/datas/usecases.json"

export const UsecaseTabContent = () => {
  return (
    <Box className="w-full text-start">
      <Box className="w-full py-4">
        <Grid2 container spacing={2}>
          {usecases.map((item) => (
            <Grid2
              key={item.id}
              display={"flex"}
              flexDirection={"column"}
              justifyContent={"space-between"}
              size={{ xs: 12, sm: 12, md: 3, lg: 3, xl: 3 }}
              marginTop={2}
            >
              <Box className="h-full p-5 bg-white rounded-2xl border border-[#E6EAF2] hover:shadow-lg transition-all duration-300">
                <p className="text-[#0099B0] text-sm font-medium mb-2">Use Case {item.order}</p>
                <h6 className="line-clamp-2 text-[24px] leading-[32px] font-medium mb-3">{item.label}</h6>
                <p className="line-clamp-3 text-[#4B5563] text-[14px] leading-[22px] mb-4">
                  {item.jobAtHand || item.intro?.[0] || "Explore this use case."}
                </p>
                <Link
                  to={item.path}
                  className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#021744] text-[#021744] hover:bg-[#021744] hover:text-white transition-colors duration-300"
                >
                  View Usecase
                </Link>
              </Box>
            </Grid2>
          ))}
        </Grid2>
      </Box>
    </Box>
  )
}
